import { useEffect, useState } from 'react';

import clsx from 'clsx';

import Button from 'components/Button';
import Typography from 'components/Typography';
import fullStory from 'helpers/fullStoryCssClasses';
import { sendEvent } from 'lib/AnalyticsGDM/analytics';
import { buildAccountEmailAuthEvent } from 'shared-utils/accountEmailEvents';

import Menu from './components/Menu';
import ProfileAvatar from './components/ProfileAvatar';

import classes from './UserSignedButton.module.scss';

/** @type {import('./types').default} */
const UserSignedInButton = ({ avatarSrc, className, name }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    sendEvent(buildAccountEmailAuthEvent('form-cta-impression', true));
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    sendEvent(buildAccountEmailAuthEvent('form-cta-click', true));
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className={clsx('UserSignedInButton', classes.root)}>
      <Button
        className={clsx(classes.loggedInButton, fullStory.MASK, className)}
        onClick={handleClick}
      >
        <Typography variant="button-md" className={classes.userLabel}>
          {name}
        </Typography>
        <ProfileAvatar src={avatarSrc} className={fullStory.EXCLUDE} />
      </Button>
      {isOpen && <Menu handleClose={handleClose} />}
    </div>
  );
};

export default UserSignedInButton;
